import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-adminheader",
  templateUrl: "./adminheader.component.html",
  styleUrls: ["./adminheader.component.css"],
})
export class AdminheaderComponent implements OnInit {
  token: any;
  userName: any;
  profilePic: any;
  @Input() profileDetails = "";
  profileData: any;
  file: any = "";
  profileImage: any;
  ActivityData: any = [];
  driverIndex: any;
  truckOwnerIndex: any;
  totalIndex: any;
  username: any;

  constructor(private router: Router, private services: AdminService) { }

  ngOnInit(): void {
    this.GetProfileDetails();
    this.getActivity();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["profileDetails"].currentValue === "success") {
      this.GetProfileDetails();
    }
  }

  public GetProfileDetails() {
    this.token = localStorage.getItem("adminToken");
    this.userName = localStorage.getItem("adminUserName");
    this.profilePic = localStorage.getItem("adminProfile");
    if (!this.username) {
      this.getProfile();
      // localStorage.clear;
      // localStorage.removeItem("adminToken");
      localStorage.removeItem("adminUserName");
      localStorage.removeItem("adminProfile");
    }
  }

  GoToProfile() {
    this.router.navigateByUrl("adminprofile");
  }

  GoToActivity() {
    this.router.navigateByUrl("/admin/activity-log");
  }
  getActivity() {
    this.services.activityGet(this.token).subscribe((response: any) => {
      this.ActivityData = response.body.data;
      this.driverIndex = this.ActivityData.driver.length;
      this.truckOwnerIndex = this.ActivityData.truckowner.length;
      this.totalIndex = this.driverIndex + this.truckOwnerIndex;
    });
  }
  public getProfile() {
    this.services.profileGet(this.token).subscribe((response: any) => {
      this.profileData = response.body.data;
      localStorage.setItem("adminUserName", this.profileData.username);
      localStorage.setItem("adminProfile", this.profileData.profile_pic);
      this.userName = this.profileData.username;
      console.log("this.profileData", this.profileData);

      this.profilePic = this.profileData.profile_pic;
    });
  }
  logout() {
    // localStorage.clear();
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUserName");
    localStorage.removeItem("adminProfile");
    this.router.navigateByUrl("admin/login");
  }

  toggleSidebar() {
    this.services.toggleSidebar.next();
  }
}
